import React from 'react';
import PropTypes from 'prop-types';

import { STATS_LEADERS_COLUMNS } from '../config/columns';
import { Loader } from '../../../../../../../common/react/components/Loader';

/**
 * @typedef {object} Props
 * @property {object} sort
 * @property {object} season
 * @property {object} round
 */

/**
 * @param {Props} props - Props.
 * @returns {JSX.Element} Loader or heading.
 */
export const Heading = ( { sort, season, round } ) => {
    if ( !season || !sort.columnId ) {
        return (
            <div className="stats-leaders-table-header__heading">
                <Loader />
            </div>
        );
    }

    const sortByColumn = STATS_LEADERS_COLUMNS[ sort.columnId ].name;

    // eslint-disable-next-line no-magic-numbers
    const seasonYear = season.providerId.slice( 4, 8 );

    return (
        <h2 className="stats-leaders-table-header__heading">
            <strong>{ sortByColumn }</strong> - { seasonYear } Season{' '}
            { round && `(Round ${ round.roundNumber })` }
        </h2>
    );
};

Heading.propTypes = {
    sort: PropTypes.object.isRequired,
    season: PropTypes.object,
    round: PropTypes.object
};